module.exports = __webpack_public_path__ + "static/img/icon.f67a835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = 173
// module chunks = 25